import { useAuth0 } from '@/utils/auth/auth0'

/**
 * Thin wrapper around Auth0's getAccessTokenSilently.
 * Decouples step components from Auth0 — one import to change if auth changes.
 */
export function useToken() {
  const { getAccessTokenSilently } = useAuth0()
  return { getToken: getAccessTokenSilently }
}
